var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoForQr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 39.5 7 L 37.5 10 L 36 9.5 L 39.5 7 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 42.5 7 L 44 11 L 48 12 L 47.5 14 L 42 12 L 42.5 7 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 34.5 10 L 34.5 13 Q 32.3 13.8 33 11.5 L 34.5 10 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 29.5 12 L 28.5 14 L 29.5 12 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 22.5 16 L 24 19 L 21 17.5 L 22.5 16 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 72.5 24 L 79 27.5 L 77.5 28 Q 72.9 26.8 72.5 24 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 69.5 25 L 73 27.5 L 70.5 29 L 69.5 25 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 8.5 27 L 11 28.5 L 9.5 28 L 8.5 27 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 55.5 30 L 56 32 L 58 32.5 L 56.5 33 L 52 31.5 L 55.5 30 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 63.5 30 L 71.5 30 L 72 31.5 L 68.5 31 Q 62.5 32.3 63.5 30 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 44.5 31 L 47 31.5 L 44.5 32 L 44.5 31 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 85.5 31 L 87.5 34 L 85.5 31 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 73.5 32 L 77 32.5 L 73.5 33 L 73.5 32 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 13.5 36 L 14 38.5 L 13 38.5 L 13.5 36 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 16.5 40 L 17.5 42 L 15 41.5 L 16.5 40 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 35.5 40 L 36 44 L 33 43.5 L 35.5 40 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 36.5 45 L 37.5 47 Q 34.7 47.7 36.5 45 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 44.5 56 L 45 58 L 43 57.5 L 44.5 56 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 24.5 57 L 25.5 59 L 24.5 57 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 44.5 65 L 48 66.5 L 46.5 66 Q 43.5 66.5 44.5 65 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 39.5 6 L 41 6.5 L 15.5 19 L 15.5 18 L 39.5 6 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 44.5 7 L 52 11.5 L 50.5 11 Q 44.9 10.2 44.5 7 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 55.5 13 L 59 15.5 L 57.5 15 L 55.5 13 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 62.5 17 L 66 19.5 L 64.5 19 L 62.5 17 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 13.5 19 L 12.5 21 L 6 24.5 L 7 26.5 L 5 25.5 Q 3.9 22.2 6.5 23 L 13.5 19 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 69.5 21 L 73 23.5 L 71.5 23 L 69.5 21 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 76.5 25 L 84 29.5 L 82.5 30 L 77.5 27 L 76.5 25 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 8.5 30 L 13 37.5 L 11 36.5 L 8.5 30 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 85.5 30 L 89 32.5 L 87.5 32 L 85.5 30 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 48.5 31 L 54 32.5 L 45.5 33 L 45.5 32 L 48.5 31 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 32.5 32 L 35 37.5 L 33 36.5 L 32.5 32 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 62.5 33 L 80 33.5 L 62.5 34 L 62.5 33 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 90.5 33 L 93 34.5 L 84.5 35 L 84.5 34 Q 89.2 35.2 90.5 33 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 35.5 39 L 41 48.5 L 39 47.5 L 35.5 39 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 14.5 41 L 18 46.5 L 16 45.5 L 14.5 41 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 18.5 48 L 24 57.5 L 23 57.5 L 18.5 48 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 41.5 50 L 44 53.5 L 42 52.5 L 41.5 50 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 45.5 57 L 52 67.5 L 49.5 68 L 49 65.5 L 45 58.5 L 45.5 57 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 32.5 62 L 35 62.5 L 32.5 63 L 32.5 62 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 40.5 5 L 48 8.5 L 46.5 8 L 40.5 6 L 40.5 5 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 51.5 10 L 55 12.5 L 53.5 12 L 51.5 10 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 58.5 14 L 62 16.5 L 60.5 16 L 58.5 14 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 65.5 18 L 71 21.5 L 69.5 21 Q 65.5 20.5 65.5 18 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 9.5 20 L 11 20.5 L 8.5 22 L 9.5 20 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 72.5 22 L 78 25.5 L 76.5 25 Q 72.5 24.5 72.5 22 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 5.5 26 L 9 31.5 L 7 30.5 L 5.5 26 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 81.5 27 L 87 30.5 L 85.5 30 Q 81.5 29.5 81.5 27 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 88.5 31 L 94 34.5 Q 94.6 37.3 88.5 36 L 88.5 35 L 93 34.5 Q 88.7 33.7 88.5 31 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 33.5 32 L 45 32.5 L 33.5 33 L 33.5 32 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 51.5 33 L 62 33.5 L 51.5 34 L 51.5 33 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 33.5 34 L 37 39.5 L 35 38.5 L 33.5 34 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 68.5 34 L 84 34.5 L 68.5 35 L 68.5 34 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 11.5 37 L 15 42.5 L 13 41.5 L 11.5 37 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 38.5 43 L 43 50.5 L 41 49.5 L 38.5 43 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 16.5 46 L 20 51.5 L 18 50.5 L 16.5 46 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 44.5 54 L 48 59.5 L 46 58.5 L 44.5 54 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 21.5 55 L 24 60 L 26 60.5 L 24.5 61 L 21.5 55 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 33.5 63 L 36 63.5 L 33.5 64 L 33.5 63 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 37.5 64 L 42 65.5 L 39.5 66 L 37.5 64 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 50.5 65 L 51.5 67 L 50.5 65 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.6392156862745098,
    d: "M 46.5 67 L 53 68.5 L 49.5 69 L 46.5 68 L 46.5 67 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 39.5 4 Q 46.8 3.8 49 8.5 L 46.5 7 L 40.5 5 L 15.5 18 L 15 16 L 39.5 4 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 50.5 8 L 59.5 14 L 64 15 L 65 17.5 L 63.5 17 L 50 10 L 50.5 8 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 12.5 18 L 14 18.5 L 9.5 20 L 9.5 19 L 12.5 18 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 66.5 18 Q 69.8 16.9 69 19.5 L 67.5 19 L 66.5 18 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 7.5 20 L 8 22 L 3.5 24 L 5.5 21 L 7.5 20 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 70.5 20 L 76 23.5 L 74.5 23 Q 70.5 22.5 70.5 20 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 77.5 24 L 79.5 24 L 89.5 31 L 92 31 L 91.5 33 L 78.5 26 L 77.5 24 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 4.5 25 L 7 29.5 L 5 28.5 L 4.5 25 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 7.5 31 L 13 40.5 L 11 39.5 L 7 32.5 L 7.5 31 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 33.5 33 L 50.5 33 L 57 34.5 L 52.5 36 Q 47.8 32.2 37.5 34 L 36 36.5 L 49 60.5 L 48 60.5 L 33.5 33 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 93.5 33 L 96 34 Q 97 37 94 36 L 93.5 33 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 58.5 34 Q 66.7 32.3 70 35.5 L 68.5 36 L 67.5 35 L 58.5 35 L 58.5 34 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 79.5 35 L 88 35.5 L 79.5 36 L 79.5 35 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 13.5 42 L 22 56.5 L 20 57 L 19 52 Q 16 53.3 17 49.5 L 13 43.5 L 13.5 42 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 23.5 60 L 33 63.5 L 30.5 64 L 24.5 62 L 23.5 60 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 49.5 62 Q 51.8 61.3 51 63.5 L 52 65.5 L 50 64.5 L 49.5 62 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 34.5 64 L 39 65.5 L 36.5 66 L 34.5 64 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 40.5 66 L 52.5 69 L 52.5 67 Q 55.5 66.2 54 70 Q 46.7 70.7 42.5 67 Q 40.7 69.5 40.5 66 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.08627450980392157,
    d: "M 89.5 76 L 90.5 78 L 89.5 76 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 41.5 6 L 42 12 L 47.5 14 L 48 12.5 Q 45.7 11.3 48.5 10 Q 50.8 14.2 53 12.5 L 52.5 14 L 54.5 13 L 58 15 L 58.5 17 L 60 16.5 L 60 18 Q 63.7 16.5 63 19.5 L 63.5 22 Q 66.8 23.1 66 20.5 L 67 20.5 L 68.5 23 L 70.5 23 L 72 23 Q 70.5 26.8 73.5 26 L 80.5 28 L 83 30.5 L 80 31 Q 78.9 33.7 81.5 33 L 81.5 34 L 73.5 32 L 68.5 33 L 68.5 32 L 70.5 31 L 72 31.5 L 71 29.5 Q 74.8 27.8 71.5 26 L 69 27.5 Q 71.3 28.8 68.5 30 L 62.5 29 L 63.5 31 Q 67.3 30 66 33 L 61 32.5 Q 63.3 31.3 60.5 30 L 58 30.5 L 58.5 32 L 54.5 33 L 54.5 32 Q 56.8 32.8 56 30.5 L 54 30.5 L 54.5 29 Q 50.8 28.3 50 30.5 L 52 31.5 L 50.5 32 L 48.5 31 L 47 31.5 L 46.5 30 Q 45.1 32.6 40.5 32 L 36.5 32 L 34.5 30 L 33 30.5 L 33.5 32 L 32 32 L 32 37 L 35 38.5 L 34 40.5 Q 36.3 41.8 33.5 43 L 32 43.5 L 32.5 46 L 34.5 47 L 35 44 L 38 44.5 L 36 45 L 37 47.5 L 36 50 Q 39 51.3 38 47.5 L 39 47.5 L 39.5 50 L 41 49.5 L 40.5 51 L 42 51.5 L 42 53.5 L 42.5 55 L 44 54.5 L 43.5 58 L 46.5 60 L 47 62.5 L 49 65.5 L 47.5 65 Q 41 66.5 39.5 63 Q 38.3 65.3 37 62.5 L 36 59.5 L 36.5 58 L 34 59.5 Q 34.8 61.8 32.5 61 Q 31.3 63.3 30 60.5 Q 30.8 57.9 27.5 59 L 25.5 60 L 24 56.5 Q 25.1 53.2 22.5 54 L 21.5 52 Q 26.3 53.7 25 49.5 L 22.5 51 L 20 50.5 L 21 47.5 L 18 46 L 16 42.5 L 18 42.5 L 17 40.5 L 18 38 Q 15.3 36.9 16 39.5 L 14 40.5 L 14.5 37 L 16 37.5 Q 16.8 34.9 13.5 36 L 12 36.5 L 11 31 L 8 29.5 L 6 25.5 L 7.5 23 L 8 26 L 10 25.5 L 9 22.5 L 11 22.5 L 11 21 Q 14.8 22.5 14 19.5 L 15.5 20 L 20.5 22 L 21 20 Q 17.2 21.5 18 18.5 Q 19.2 15.8 20.5 18 L 24.5 19 L 24 17.5 L 23 15.5 L 27.5 13 L 28.5 14 L 32 11.5 Q 31.3 13.8 33.5 13 L 35.5 14 L 33.5 10 L 37.5 12 L 41.5 6 Z M 39 11 L 39 13 L 41 12 L 39 11 Z M 30 14 L 30 15 L 32 15 L 30 14 Z M 54 17 L 56 21 L 60 22 L 60 20 L 54 17 Z M 11 26 L 8 28 L 11 29 L 11 26 Z M 40 29 L 40 30 L 43 30 L 40 29 Z M 74 30 L 74 31 L 78 31 L 74 30 Z M 19 43 Q 18 46 21 45 Q 22 42 19 43 Z M 22 45 Q 20 48 23 47 L 22 45 Z M 40 57 L 38 60 L 40 61 L 40 57 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 84.5 30 L 85 33 L 87.5 32 L 86.5 34 L 84 32.5 L 84.5 30 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 100 0 L 100 100 L 62 99.5 L 64.5 97 L 76.5 94 L 78.5 92 Q 86.6 91.1 91.5 87 Q 93.3 89.8 95 85.5 L 89 73 Q 86 74.3 87 70.5 L 79 57.5 L 71.5 49 L 69.5 48 L 67.5 49 L 60.5 45 L 55.5 45 L 51.5 42 Q 46.1 42.6 44 41 L 45 47 Q 47.7 45.9 47 48.5 L 49 53 L 51 53.5 L 50 54.5 L 54 58.5 L 54 60.5 L 62 72.5 L 58.5 74 Q 57.1 71.4 52.5 72 L 47.5 73 L 42.5 72 L 40.5 73 Q 39 69.5 32.5 71 Q 31 73.5 29.5 70 L 20.5 71 L 15.5 69 Q 14 71.5 8.5 70 L 5.5 69 L 4 71.5 Q 7.2 75.6 13 76 Q 11.7 79.3 16.5 78 L 32.5 88 L 47 94 Q 45.9 96.7 48.5 96 L 54 99.5 L 0 100 L 0 0 Z M 42 3 L 17 16 Q 14 15 15 18 L 12 19 Q 8 18 9 21 L 8 20 L 3 24 L 17 50 Q 16 53 19 52 L 20 56 Q 19 58 22 57 L 23 61 L 27 63 L 40 66 Q 41 69 43 67 Q 47 71 54 70 Q 55 66 52 67 L 51 64 Q 52 61 49 62 L 49 59 L 36 35 L 42 34 Q 49 33 53 36 L 56 35 L 68 35 L 69 36 L 71 35 L 79 35 L 80 36 L 96 36 L 96 34 L 94 33 Q 91 34 92 31 L 88 30 L 80 24 L 77 24 L 71 20 Q 68 21 69 18 L 66 18 L 64 15 L 62 15 L 52 9 L 50 9 L 42 3 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 43.5 8 Q 46.1 7.3 45 10 L 47.5 10 L 46.5 12 L 44 11 L 43.5 8 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 35.5 9 L 37.5 10 L 39.5 9 L 39.5 11 L 41 11.5 L 39 12.5 L 38.5 11 L 36.5 11 Q 33.7 11.7 35.5 9 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 51.5 12 L 54 13.5 L 52.5 14 L 51.5 12 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 29.5 14 L 32 14.5 L 29.5 15 L 29.5 14 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 20.5 17 L 19.5 19 L 20.5 17 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 54.5 17 L 60 19.5 L 59.5 22 L 54.5 18 L 54.5 17 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 17.5 18 L 18 20 Q 21.8 18.5 21 21.5 L 19.5 21 L 15 19.5 L 17.5 18 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 64.5 19 L 65.5 21 L 63.5 22 L 62.5 20 L 64 20.5 L 64.5 19 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 8.5 23 L 11 27.5 L 9 28.5 L 10 26 Q 6.5 27.1 8.5 23 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 71.5 28 L 70.5 30 L 69 29.5 L 71.5 28 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 39.5 29 L 43 29.5 L 39.5 30 L 39.5 29 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 51.5 29 L 55 29.5 Q 54.3 31.8 50.5 31 L 51.5 29 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 58.5 30 L 62 31.5 L 58.5 33 L 58.5 30 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 73.5 30 L 78 30.5 L 73.5 31 L 73.5 30 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 66 31 L 69 31.5 L 66 33 L 66 31 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 80 31 Q 85.6 29.1 84 34 Q 81.3 35.1 82 32.5 L 80 32.5 L 80 31 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 14.5 36 Q 17.1 35.3 16 38 L 18 38 L 18 40 L 15.5 41 L 16 39.5 L 14.5 36 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 17.5 42 L 16.5 44 L 17.5 42 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 19.5 43 Q 21.8 42.3 21 44.5 L 22.5 47 Q 19.9 46.2 21 49.5 L 20 49.5 Q 21.1 46.2 18.5 47 L 18.5 46 L 20.5 47 L 21 45.5 L 19.5 43 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 32.5 43 L 35 44 L 34.5 47 L 32 45.5 L 32.5 43 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 37.5 45 Q 40.3 46.3 38 47.5 Q 39 51.3 36 50 L 38 46.5 L 37.5 45 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 24.5 49 L 25 51 L 21.5 52 L 21.5 51 L 24.5 49 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 42.5 53 L 44 55.5 L 42 54.5 L 42.5 53 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 40.5 55 L 41 56.5 L 39 57.5 L 40.5 55 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 35.5 58 L 37 58.5 L 35 59 L 35.5 61 L 37 60.5 Q 38.1 63.8 35.5 63 L 34 59.5 L 35.5 58 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 38.5 59 Q 40.8 58.3 40 60.5 L 38.5 59 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 47.5 65 L 50 66.5 L 48.5 67 L 47.5 65 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 45.5 43 L 48 43.5 Q 45.9 46.8 45.5 43 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 52.5 45 L 58 46.5 L 55.5 47 L 52.5 46 L 52.5 45 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 47.5 46 L 48.5 48 L 47.5 46 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 61.5 48 L 69 50.5 L 67.5 51 L 61.5 49 L 61.5 48 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 49.5 49 L 52 52.5 L 50 51.5 L 49.5 49 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 70.5 51 L 74 52.5 L 72.5 52 Q 69.5 52.5 70.5 51 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 52.5 54 L 53.5 56 L 52.5 54 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 75.5 56 L 76.5 58 L 75.5 56 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 54.5 57 L 55.5 59 L 54.5 57 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 77.5 59 L 82 65.5 L 80 64.5 L 77.5 59 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 57.5 62 L 58.5 64 L 57.5 62 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 59.5 65 L 64 71.5 L 62 70.5 L 59.5 65 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 82.5 67 L 83.5 69 L 82.5 67 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 5.5 70 L 9 72.5 L 7.5 72 L 5.5 70 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 84.5 70 L 85.5 72 L 84.5 70 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 10.5 71 L 16 71.5 L 10.5 72 L 10.5 71 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 20.5 72 L 29 72.5 L 20.5 73 L 20.5 72 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 32.5 72 L 44 73.5 L 34.5 74 L 32.5 72 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 64.5 73 L 66 76 L 56 75.5 L 65 74.5 L 64.5 73 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 86.5 73 L 89 76.5 L 87 75.5 L 86.5 73 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 12.5 74 L 22 79.5 L 20.5 79 L 13.5 76 L 12.5 74 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 45.5 74 L 53 74.5 L 45.5 75 L 45.5 74 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 89.5 78 L 94 84.5 L 91.5 86 L 91.5 85 L 93 84.5 L 89.5 78 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 27.5 82 L 37 87.5 L 35.5 87 L 28.5 84 L 27.5 82 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 88.5 86 L 90 86.5 L 86.5 88 L 86.5 87 L 88.5 86 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 42.5 90 L 48 93.5 L 46.5 93 Q 42.5 92.5 42.5 90 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 70.5 93 L 72 93.5 L 65.5 96 L 65.5 95 L 70.5 93 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8509803921568627,
    d: "M 62.5 96 L 64 96.5 L 60.5 98 L 60.5 97 L 62.5 96 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 37.5 34 L 41 34.5 L 37.5 35 L 37.5 34 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 44.5 42 L 47 42.5 L 44.5 43 L 44.5 42 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 48 42 L 54 44.5 L 51.5 45 L 48 44 L 48 42 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 45.5 44 L 50 50.5 L 48 51 L 45.5 44 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 57.5 45 L 63 47.5 L 60.5 48 L 57.5 45 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 64.5 48 L 72 50.5 L 69.5 51 L 64.5 49 L 64.5 48 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 49.5 52 L 52 53.5 L 56 59.5 L 54 60.5 L 51 53 L 49.5 52 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 74.5 53 Q 76.8 52.3 76 54.5 Q 78.8 55.6 78 59 L 80 59.5 L 78.5 60 L 74.5 53 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 79.5 61 Q 81.8 60.3 81 62.5 L 90 75.5 L 88 76 L 79.5 61 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 57.5 63 L 60 66.5 L 58 67 L 57.5 63 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 60.5 68 L 61.5 70 Q 58.7 70.7 60.5 68 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 4.5 70 L 6.5 70 L 11 70.5 L 6 71.5 L 15 76.5 L 13.5 77 L 4 72 L 4.5 70 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 13.5 70 Q 19.3 69.3 22 71.5 L 16.5 72 L 13.5 71 L 13.5 70 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 23.5 71 Q 30.3 69.3 32 72.5 L 29.5 73 Q 28.3 70.8 23.5 72 L 23.5 71 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 61.5 71 L 64 72.5 L 65 74.5 L 60.5 75 L 60.5 74 Q 64.3 75 63 72 L 61.5 71 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 34.5 72 L 40 72.5 L 34.5 73 L 34.5 72 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 44.5 73 L 48 73.5 L 44.5 74 L 44.5 73 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 50.5 73 Q 57.3 71.3 59 74.5 L 53.5 75 L 50.5 74 L 50.5 73 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 89.5 77 L 92 78 L 93 81.5 L 91 80.5 L 89.5 77 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 18.5 78 L 25 81 L 24.5 83 L 18 80 L 18.5 78 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 26.5 82 L 27.5 84 Q 24.7 84.7 26.5 82 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 93.5 83 Q 96.3 84.3 94 85.5 Q 94.9 88.5 90.5 87 L 90.5 86 L 94 84.5 L 93.5 83 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 31.5 85 L 51 95 L 50.5 97 Q 42.3 90 31 87 L 31.5 85 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 85.5 88 L 87 88.5 L 82.5 91 L 82 89 L 85.5 88 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 77.5 91 L 79 91.5 L 75.5 94 L 72.5 94 L 58.5 100 L 59.5 98 L 77.5 91 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.2196078431372549,
    d: "M 52.5 96 L 57 98 L 56.5 100 L 52 98 L 52.5 96 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 50.5 42 L 54 43.5 L 52.5 44 L 50.5 42 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 58.5 45 L 63 46.5 L 61.5 47 L 58.5 46 L 58.5 45 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 69.5 48 L 72 49.5 L 70.5 50 L 69.5 48 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 84.5 67 L 85.5 69 L 84.5 67 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 5.5 69 L 8 69.5 L 5.5 70 L 5.5 69 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 25.5 70 L 30 70.5 L 25.5 71 L 25.5 70 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 32.5 71 L 39 71.5 L 32.5 72 L 32.5 71 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 42.5 72 L 47 72.5 L 42.5 73 L 42.5 72 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 52.5 72 L 56 72.5 L 52.5 73 L 52.5 72 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 31.5 73 L 34 73.5 L 31.5 74 L 31.5 73 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 42.5 74 L 45 74.5 L 42.5 75 L 42.5 74 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 53.5 98 L 56 99.5 L 54.5 100 L 53.5 98 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 0.8745098039215686,
    d: "M 62.5 98 L 61.5 100 L 60 99.5 L 62.5 98 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 44 L 73 52 L 93 84.5 L 59.5 98 L 56.5 98 L 9 72.5 L 19.5 72 L 20.5 73 L 41.5 74 L 42.5 75 L 66 76 L 49 48.5 L 47.5 44 Z M 61 52 Q 59 58 61 61 L 63 60 L 62 62 L 64 65 L 63 67 L 67 68 L 65 68 L 65 69 Q 68 68 67 71 L 71 71 Q 73 77 70 79 L 65 78 L 62 79 L 59 78 L 55 79 L 54 78 L 44 78 L 43 77 L 41 78 L 37 78 L 31 79 Q 30 83 36 81 L 38 81 Q 40 82 38 84 L 39 86 L 41 85 Q 47 83 45 89 L 52 90 Q 54 89 53 93 L 67 93 L 67 89 L 71 89 L 71 91 L 72 91 L 74 88 L 74 86 L 78 85 L 80 85 L 84 86 Q 86 85 85 80 Q 83 76 81 78 L 81 71 L 77 71 L 78 68 L 75 67 L 75 66 L 74 62 L 71 61 L 71 56 L 67 56 Q 68 52 66 53 L 61 52 Z M 83 73 L 82 76 L 83 76 L 83 73 Z M 62 77 L 62 78 L 64 78 L 62 77 Z M 87 78 L 86 81 L 87 81 L 87 78 Z M 80 86 L 80 87 L 82 87 L 80 86 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 52 L 65.5 53 Q 68.5 52.2 67 56 L 71 56 L 71 60.5 L 74 61.5 L 75 65.5 L 74.5 67 L 78 67.5 L 77 71 L 81 71 L 81 77.5 Q 83 75.8 85 79.5 Q 86.3 84.8 83.5 86 L 79.5 85 L 79.5 86 L 82 86.5 L 79.5 87 Q 78.8 84.3 74.5 85 L 74 87.5 L 72 90.5 L 71 90.5 L 71 89 L 67 89 L 66.5 93 L 53 93 Q 54.5 89.2 51.5 90 L 45 89 Q 47.3 83 40.5 85 L 40.5 87 L 38 83.5 Q 40.3 82.3 37.5 81 L 35.5 81 Q 29.6 82.7 31 79 Q 36 80.3 37.5 77 Q 39 80.5 40.5 78 L 42.5 77 L 43.5 78 L 53.5 78 L 54.5 79 L 58.5 78 Q 60 80.5 61.5 77 L 65.5 79 L 69.5 79 Q 72.8 77.1 71 71 L 67 71 Q 68.3 68 64.5 69 L 64.5 68 L 67 67.5 L 63 66.5 L 64 64.5 L 61.5 61 L 59.5 62 L 59.5 61 Q 61.8 61.8 61 59.5 Q 58.2 57.7 60.5 52 Z M 62 78 L 62 79 L 64 79 L 62 78 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 73 L 83 75.5 L 82 75.5 L 82.5 73 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32, 32, 31)",
    stroke: "rgb(32, 32, 31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 78 L 87 80.5 L 86 80.5 L 86.5 78 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForQr);
export default __webpack_public_path__ + "static/media/logo-for-qr.cbb0bbb52e7711bdc2f7cb3a926c9047.svg";
export { ForwardRef as ReactComponent };